import React, { FC } from 'react';
import { bindTrigger, InjectedProps } from '@maas-components/x-popup-state';
import { Avatar, Badge, IconButton, Stack, Text, Theme, useMediaQuery, useTheme } from '@maas-components/core';
import { PersonOutline } from '@maas-components/icons';
import useStyles from '../styles';
import { Seller } from '../../types';

export type ProfileButtonProps = {
    currentSeller?: Seller;
    enableUserInfo: boolean;
    name: string;
    popupState: InjectedProps;
    mode: 'dark' | 'light';
};

const ProfileButton: FC<ProfileButtonProps> = ({ currentSeller, enableUserInfo, name, popupState, mode }) => {
    const classes = useStyles({ mode });
    const theme: Theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <IconButton
            data-testid="profile-button-test-id"
            size="small"
            color="inherit"
            className={classes.profileButton}
            {...bindTrigger(popupState)}
        >
            <Stack spacing={2} direction="row" alignItems="center">
                {currentSeller ? (
                    <Badge
                        className={classes.sellerBadge}
                        overlap="circular"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        badgeContent={
                            <Avatar className={classes.sellerAvatarBadge} alt={currentSeller.legalName}>
                                {currentSeller?.legalName && currentSeller.legalName.substring(0, 1).toUpperCase()}
                            </Avatar>
                        }
                    >
                        <Avatar alt={name} className={classes.avatar}>
                            <PersonOutline color={mode === 'light' ? 'inherit' : 'secondary'} fontSize="large" />
                        </Avatar>
                    </Badge>
                ) : (
                    <Avatar alt={name} className={classes.avatar}>
                        <PersonOutline color={mode === 'light' ? 'inherit' : 'secondary'} fontSize="large" />
                    </Avatar>
                )}
                {enableUserInfo && !isMobile && (
                    <Stack>
                        <Text fontSize="small" fontWeight="bold" className={classes.userInfo}>{`Olá, ${name}`}</Text>
                        {currentSeller && (
                            <Text fontSize="small" className={classes.companyName}>
                                {currentSeller.legalName}
                            </Text>
                        )}
                    </Stack>
                )}
            </Stack>
        </IconButton>
    );
};

export default ProfileButton;
